import React, { useEffect, useState } from 'react';


const BiFormCell = (props) => {

    if (props.responsive == true) {

        return (

            <div className={props.col == null ? "col-lg-3" : props.col} style={{ padding: "2px" }}>
                {props.children}
            </div>
        );
    } else {
        return (

            <td style={props.style} valign={props.valign == null ? "" : props.valign} colSpan={props.colSpan == null ? 1 : props.colSpan} rowSpan={props.rowSpan == null ? 1 : props.rowSpan}>
                {props.children}
            </td>
        );
    }
}

export default BiFormCell;

